
define('modules/application/wizard/steps/zoneStep/complexZoneStep/audioVideoZoneStep/zoneModel',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  //Classes
  "../zoneModel"
],

function(
  app,
  Backbone,
  jQueryUi,
  ZoneModel) {

  var audioVideoZoneStepZoneModel = ZoneModel.extend({


    addConstructors   : function() {
      ZoneModel.prototype.addConstructors.apply(this);
    },


    initialize        : function()  {
      ZoneModel.prototype.initialize.apply(this);

      this.unbind("change:amplifierAndLoudSpeakersModel", this.amplifierAndLoudSpeakersModelChangedEventHandler);
      this.bind("change:amplifierAndLoudSpeakersModel",   this.amplifierAndLoudSpeakersModelChangedEventHandler, this);

      this.unbind("change:amplifierCommandModel",         this.amplifierCommandModelChangedEventHandler);
      this.bind("change:amplifierCommandModel",           this.amplifierCommandModelChangedEventHandler, this);

      this.unbind("change:vdesModel",                     this.vdesModelChangedEventHandler);
      this.bind("change:vdesModel",                       this.vdesModelChangedEventHandler, this);

      this.unbind("change:apartmentInterfaceModel",       this.apartmentInterfaceModelChangedEventHandler);
      this.bind("change:apartmentInterfaceModel",         this.apartmentInterfaceModelChangedEventHandler, this);

      this.unbind("change:sourcesModel",                  this.sourcesModelChangedEventHandler);
      this.bind("change:sourcesModel",                    this.sourcesModelChangedEventHandler, this);

      this.unbind("change:handsetsModel",                 this.handsetsModelChangedEventHandler);
      this.bind("change:handsetsModel",                   this.handsetsModelChangedEventHandler, this);

      this.unbind("change:telephonyModel",                this.telephonyModelChangedEventHandler);
      this.bind("change:telephonyModel",                  this.telephonyModelChangedEventHandler, this);

      window.BticinoS4B.eventAggregator.bind("zoneValidityUpdate:request", this.updateZoneValidity, this);
    },


    amplifierAndLoudSpeakersModelChangedEventHandler : function()  {
      this.get("amplifierAndLoudSpeakersModel").unbind("item:added",   this.updateZoneValidity);
      this.get("amplifierAndLoudSpeakersModel").bind("item:added",     this.updateZoneValidity, this);

      this.get("amplifierAndLoudSpeakersModel").unbind("item:removed", this.updateZoneValidity);
      this.get("amplifierAndLoudSpeakersModel").bind("item:removed",   this.updateZoneValidity, this);

      this.get("amplifierAndLoudSpeakersModel").unbind("item:changed", this.updateZoneValidity);
      this.get("amplifierAndLoudSpeakersModel").bind("item:changed",   this.updateZoneValidity, this);
    },

    amplifierCommandModelChangedEventHandler : function()  {
      this.get("amplifierCommandModel").unbind("item:added",   this.updateZoneValidity);
      this.get("amplifierCommandModel").bind("item:added",     this.updateZoneValidity, this);

      this.get("amplifierCommandModel").unbind("item:removed", this.updateZoneValidity);
      this.get("amplifierCommandModel").bind("item:removed",   this.updateZoneValidity, this);
    },

    apartmentInterfaceModelChangedEventHandler : function(){
      if ( (this.get("apartmentInterfaceModel")) && (this.get("apartmentInterfaceModel").attributes))
      {
        this.get("apartmentInterfaceModel").unbind("change:value",     this.updateZoneValidityInterface);
        this.get("apartmentInterfaceModel").bind("change:value",       this.updateZoneValidityInterface, this);
      }
    },
    updateZoneValidityInterface: function(){
      if(BticinoS4B.Instances.Models.ApplicationModel.attributes.choosenDistributionSystem.packageClassId == "6601")
        this.updateZoneValidity();
    },

    vdesModelChangedEventHandler                     : function()  {

      if ( (this.get("apartmentInterfaceModel")) && (this.get("apartmentInterfaceModel").attributes) )
      {
        this.get("apartmentInterfaceModel").unbind("change:value",     this.updateZoneValidity);
        this.get("apartmentInterfaceModel").bind("change:value",       this.updateZoneValidity, this);
      }

      if ( (this.get("vdesModel")) && (this.get("vdesModel").attributes) )
      {
        this.get("vdesModel").unbind("item:added",     this.updateZoneValidity);
        this.get("vdesModel").bind("item:added",       this.updateZoneValidity, this);

        this.get("vdesModel").unbind("item:removed",   this.updateZoneValidity);
        this.get("vdesModel").bind("item:removed",     this.updateZoneValidity, this);
      }

    },

    sourcesModelChangedEventHandler                     : function()  {
      if ( (this.get("sourcesModel")) && (this.get("sourcesModel").attributes) )
      {
        this.get("sourcesModel").unbind("item:added",  this.updateZoneValidity);
        this.get("sourcesModel").bind("item:added",    this.updateZoneValidity, this);

        this.get("sourcesModel").unbind("item:removed",this.updateZoneValidity);
        this.get("sourcesModel").bind("item:removed",  this.updateZoneValidity, this);
      }
    },

    handsetsModelChangedEventHandler                 : function()  {
      this.get("handsetsModel").unbind("item:added",   this.updateZoneValidity);
      this.get("handsetsModel").bind("item:added",     this.updateZoneValidity, this);

      this.get("handsetsModel").unbind("item:removed", this.updateZoneValidity);
      this.get("handsetsModel").bind("item:removed",   this.updateZoneValidity, this);
    },

    telephonyModelChangedEventHandler                : function() {
      this.get("telephonyModel").unbind("abilitation:changed",   this.updateZoneValidity);
      this.get("telephonyModel").bind("abilitation:changed",     this.updateZoneValidity, this);

      this.get("telephonyModel").unbind("vctQuantity:changed",   this.updateZoneValidity);
      this.get("telephonyModel").bind("vctQuantity:changed",     this.updateZoneValidity, this);
    },

    validateRegularZone : function() {
      var amplifierAndLoudSpeakersModel  = this.get("amplifierAndLoudSpeakersModel"),
          amplifierCommandModel          = this.get("amplifierCommandModel"),
          zoneValid                      = false,
          numberOfBusDependentAmplifiers = 0;

      if (amplifierAndLoudSpeakersModel && amplifierAndLoudSpeakersModel.attributes)
      {
        zoneValid = ( amplifierAndLoudSpeakersModel.get("collection") && amplifierAndLoudSpeakersModel.get("collection").models.length>0 );
        numberOfBusDependentAmplifiers = amplifierAndLoudSpeakersModel.getNumberOfBusDependentAmplifiers();

        //if (numberOfBusDependentAmplifiers>0 && amplifierCommandModel && amplifierCommandModel.attributes)
        //  zoneValid = ( amplifierCommandModel.get("collection") && amplifierCommandModel.get("collection").models.length>0 && amplifierCommandModel.get("collection").models.length>=numberOfBusDependentAmplifiers );

      }
      else
        zoneValid = true;

      this.set("valid", zoneValid);
    },

    validateVdesZone        : function()  {
      var vdesModel                   = this.get("vdesModel"),
          apartmentInterfaceModel     = this.get("apartmentInterfaceModel"),
          vdesModelValid              = false,
          sourcesModelValid           = false,
          filterId                    = BticinoS4B.Instances.Models.ApplicationModel.get("filterId");

      if ( (apartmentInterfaceModel) && (apartmentInterfaceModel.get("value")) )
      {
        apartmentInterfaceModelValid = true;
      }
      else
      {
        apartmentInterfaceModelValid = false;
      }

      if ( (vdesModel) && (vdesModel.get("enabled")) )
      {
        if ( (vdesModel.get("collection")) && (vdesModel.get("collection").models.length>0) )
          vdesModelValid = true;
        else
          vdesModelValid = false;
      }

      switch(filterId) {
        case -1:  zoneValid = false;
                  break;
        case  1:
        case  2:


        case  4:
        case  5:  zoneValid = (vdesModelValid || apartmentInterfaceModelValid);
                  break;
        case  3:  zoneValid = true;
                  break;
        default:  zoneValid = false;
      }

      this.set("valid", zoneValid);
    },


    validateHandsetsZone        : function()  {
      var handsetsModel  = this.get("handsetsModel"),
          telephonyModel = this.get("telephonyModel"),
          zoneValid      = false,
          filterId       = BticinoS4B.Instances.Models.ApplicationModel.get("filterId");

      if ( ( (handsetsModel) && (handsetsModel.get("enabled")) ) || (telephonyModel && telephonyModel.get("value")) )
      {
        if ( ( (handsetsModel.get("collection")) && (handsetsModel.get("collection").models.length>0) ) || ( telephonyModel.get("accessories").vctQuantity>0 ) )
          zoneValid = true;
        else
          zoneValid = false;
      }
      else
        zoneValid = false;

      if (filterId===3)
        zoneValid = true;

      this.set("valid", zoneValid);
    },


    validateSourcesZone        : function()  {
      var sourcesModel                = this.get("sourcesModel"),
          vdesModelValid              = false,
          sourcesModelValid           = false,
          filterId                    = BticinoS4B.Instances.Models.ApplicationModel.get("filterId");

      if ( (sourcesModel) && (sourcesModel.get("enabled")) )
      {
        if ( (sourcesModel.get("collection")) && (sourcesModel.get("collection").models.length>0) )
          sourcesModelValid = true;
        else
          sourcesModelValid = false;
      }

      switch(filterId) {
        case  3:
        case  4:
        case  5:  zoneValid = sourcesModelValid;
                  break;
        default:  zoneValid = false;
      }

      switch(filterId)
      {
        case -1:  zoneValid = false;
                  break;
        case  1:
        case  2:  zoneValid = true;
                  break;
      }

      this.set("valid", zoneValid);
    },

    updateZoneValidity: function()
    {

      if (name==="IDS_WAV8_5_1")
        this.validateVdesZone();
      else if (this.get("name")==="IDS_WAV8_5_2")
        this.validateHandsetsZone();
      else
        this.validateRegularZone();

      this.trigger("render:requested");

      this.get("stepEventAggregator").trigger("zoneStatusCheck:requested");
    },


    isValid        : function()
    {
      var filterId = BticinoS4B.Instances.Models.ApplicationModel.get("filterId");
      var name     = this.get("name");

      if ( (name!=="IDS_WAV8_5_1") && (name!=="IDS_WAV8_5_2") && (name!=="IDS_WAV8_5_3") && (name!=="IDS_WAV8_5_4") && (name!=="IDS_WAV8_5_5"))
      {
        if (filterId<3)
          this.validateRegularZone();

        return this.get("valid");
      }
      else if (name==="IDS_WAV8_5_1")
      {
        this.validateVdesZone();
        return this.get("valid");
      }
      else if (name==="IDS_WAV8_5_2")
      {
        this.validateHandsetsZone();
        return this.get("valid");
      }
      else if (name==="IDS_WAV8_5_3")
        return true;
      else if (name==="IDS_WAV8_5_4")
      {
        this.validateSourcesZone();
        return this.get("valid");
      }
      else if (name==="IDS_WAV8_5_5")
        return true;
      else
        return this.get("valid");
    },


    deliverCurrent : function() {
    }


  });

  // Required, return the module for AMD compliance
  return audioVideoZoneStepZoneModel;

});